import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent } from '@imagise/shared';

@Component({
  selector: 'lib-guide',
  imports: [MatIconModule, TranslateModule, CardComponent],
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuideComponent {}
